import styled from '@emotion/styled';
import { Button } from '~/shared/components';

export const StyledLoadPreviousPageButton = styled(Button)<{
    isLoading?: boolean;
    isDisabled?: boolean;
}>(({ isLoading, isDisabled }) => ({
    position: 'relative',
    color: isLoading ? 'transparent' : undefined,
    ...(isDisabled && {
        pointerEvents: 'none',
        opacity: 0.5,
    }),
}));
